var _excluded = ["as"],
    _excluded2 = ["wrapElement"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useCreateElement as defaultUseCreateElement } from "reakit-system";
import { splitProps } from "reakit-utils";
import { normalizePropsAreEqual } from "reakit-utils/normalizePropsAreEqual";
import { shallowEqual } from "reakit-utils/shallowEqual";
import { forwardRef } from "./forwardRef";
import { memo } from "./memo";

/**
 * Creates a React component.
 *
 * @example
 * import { createComponent } from "reakit-system";
 *
 * const A = createComponent({ as: "a" });
 *
 * @param options
 */
export function createComponent(_ref) {
  var {
    as: type,
    useHook,
    memo: shouldMemo,
    propsAreEqual = useHook === null || useHook === void 0 ? void 0 : useHook.unstable_propsAreEqual,
    keys = (useHook === null || useHook === void 0 ? void 0 : useHook.__keys) || [],
    useCreateElement = defaultUseCreateElement
  } = _ref;

  var Comp = (_ref2, ref) => {
    var {
      as = type
    } = _ref2,
        props = _objectWithoutProperties(_ref2, _excluded);

    if (useHook) {
      var _as$render;

      var [_options, htmlProps] = splitProps(props, keys);

      var _useHook = useHook(_options, _objectSpread({
        ref
      }, htmlProps)),
          {
        wrapElement
      } = _useHook,
          elementProps = _objectWithoutProperties(_useHook, _excluded2); // @ts-ignore


      var asKeys = ((_as$render = as.render) === null || _as$render === void 0 ? void 0 : _as$render.__keys) || as.__keys;
      var asOptions = asKeys && splitProps(props, asKeys)[0];
      var allProps = asOptions ? _objectSpread(_objectSpread({}, elementProps), asOptions) : elementProps;

      var _element = useCreateElement(as, allProps);

      if (wrapElement) {
        return wrapElement(_element);
      }

      return _element;
    }

    return useCreateElement(as, _objectSpread({
      ref
    }, props));
  };

  if (process.env.NODE_ENV !== "production" && useHook) {
    Comp.displayName = useHook.name.replace(/^(unstable_)?use/, "");
  }

  Comp = forwardRef(Comp);

  if (shouldMemo) {
    Comp = memo(Comp, propsAreEqual && normalizePropsAreEqual(propsAreEqual));
  }

  Comp.__keys = keys;
  Comp.unstable_propsAreEqual = normalizePropsAreEqual(propsAreEqual || shallowEqual);

  if (useHook) {
    Comp.__displayName = useHook.name.replace(/^(unstable_)?use/, "");
  }

  return Comp;
}
//# sourceMappingURL=createComponent.js.map